/** The collected object stays hidden; the grab button indicates a throw is available. */
export class GrabButton {
  private readonly button = document.querySelector<HTMLElement>('[data-button="Grab"]');
  private rendered: boolean | null = null;

  update(carrying: boolean): void {
    if (this.rendered === carrying || !this.button) return;
    this.rendered = carrying;
    this.button.textContent = carrying ? "↗" : "✊";
    this.button.setAttribute("aria-label", carrying ? "Lancia l’oggetto" : "Raccogli un oggetto");
    this.button.title = carrying ? "Lancia (K)" : "Raccogli (K)";
  }
}
